import { AnnotationPlugin } from '@st/document-viewer-kit'
import { copyToolState, RECT_COLOR_OPTIONS, RectangleToolOverlay } from './ui'

import { RectangleAnnotationElement } from './ui'
import { RectToolState } from '~/st-doc-viewer/annotations'
import { RectangleAnnotation } from '@st/sdk'

export { RectangleToolEditor } from './ui'

const INITIAL_TOOL_STATE: RectToolState = {
  name: 'rectangle',
  settings: { border: { width: 3, color: RECT_COLOR_OPTIONS[0] } }
}

export function rectToolPlugin(): AnnotationPlugin<RectangleAnnotation, RectToolState> {
  return {
    name: 'rectangle',
    initialToolState: INITIAL_TOOL_STATE,
    ToolOverlay: RectangleToolOverlay,
    Element: RectangleAnnotationElement,
    handlesAnnotation: (annotation) => annotation.type == 'rectangle',
    onAnnotationSelected: (event, send) => {
      const annotation = event.annotationDraft ?? event.annotation
      if (annotation) {
        send({ type: 'updateTool', tool: copyToolState(annotation) })
      }
    },
    onAnnotationDeselected: (event, send) => {
      if (!event.annotation && event.annotationDraft) {
        send({ type: 'createAnnotation', annotationDraft: event.annotationDraft })
      } else if (event.annotation && event.annotationDraft) {
        send({ type: 'updateAnnotation', annotationDraft: event.annotationDraft })
      }
    }
  }
}
